import { Hero } from "../components/home/Hero";
import { TwoSouls } from "../components/home/TwoSouls";
import { FeaturedWeddings } from "../components/home/FeaturedWeddings";
import { Styles } from "../components/home/Styles";
import { CtaBand } from "../components/home/CtaBand";
import { Marquee } from "../components/site/Marquee";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <TwoSouls />
      <Styles />
      <FeaturedWeddings />
      <CtaBand />
    </main>
  );
}
